


export const layouts = {
'DefaultLayout': () => import('/app/src/layouts/DefaultLayout.vue'),
'NewV2Layout': () => import('/app/src/layouts/NewV2Layout.vue'),
'NoLayout': () => import('/app/src/layouts/NoLayout.vue'),
'partials/LeftSidebar': () => import('/app/src/layouts/partials/LeftSidebar.vue'),
'partials/NewV2FooterNav': () => import('/app/src/layouts/partials/NewV2FooterNav.vue'),
'partials/NewV2Header': () => import('/app/src/layouts/partials/NewV2Header.vue'),
'partials/OldSidebar': () => import('/app/src/layouts/partials/OldSidebar.vue'),
'partials/TopHeader': () => import('/app/src/layouts/partials/TopHeader.vue'),
}
export const createGetRoutes = (router, withLayout = false) => {
  const routes = router.getRoutes()
  if (withLayout) {
      return routes
  }
  return () => routes.filter(route => !route.meta.isLayout)
}

export function setupLayouts(routes) {
  function deepSetupLayout(routes, top = true) {
    return routes.map(route => {
      if (route.children?.length > 0) {
        route.children = deepSetupLayout(route.children, false)
      }
      
      if (top) {
        // unplugin-vue-router adds a top-level route to the routing group, which we should skip.
        const skipLayout = !route.component && route.children?.find(r => (r.path === '' || r.path === '/') && r.meta?.isLayout)  

        if (skipLayout) {
          return route
        }

        if (route.meta?.layout !== false) {
          return { 
            path: route.path,
            component: layouts[route.meta?.layout || 'DefaultLayout'],
            children: route.path === '/' ? [route] : [{...route, path: ''}],
            meta: {
              isLayout: true
            }
          }
        }
      }

      if (route.meta?.layout) {
        return { 
          path: route.path,
          component: layouts[route.meta?.layout],
          children: [ {...route, path: ''} ],
          meta: {
            isLayout: true
          }
        }
      }

      return route
    })
  }

    return deepSetupLayout(routes)

}
